function approximateScore(score: number) {
  // return a human-readable score approximation
  if (score < 1000) {
    return score;
  } else if (score < 1_000_000) {
    return `${Math.round(score / 100) / 10}k`;
  } else if (score < 1_000_000_000) {
    return `${Math.round(score / 100_000) / 10}M`;
  } else {
    return `${Math.round(score / 100_000_000) / 10}B`;
  }
}

export default approximateScore;
